import auth from './auth';

const LOCAL_CART_KEY = 'essaywriter_cart';

const localCart = {
    getCart: () => {
        try {
            const cartData = localStorage.getItem(LOCAL_CART_KEY);
            return cartData ? JSON.parse(cartData) : { items: [] };
        } catch (error) {
            console.error('Error getting cart from localStorage:', error);
            return { items: [] };
        }
    },

    saveCart: (cart) => {
        try {
            localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(cart));
        } catch (error) {
            console.error('Error saving cart to localStorage:', error);
        }
    },

    addToCart: (product) => {
        const { productId, quantity, price } = product;

        if (quantity > 10) {
            throw new Error("Du kan inte lägga till mer än 10 produkter i kundvagnen.");
        }

        const cart = localCart.getCart();
        const existingItemIndex = cart.items.findIndex(item => item.productId === productId);

        if (existingItemIndex > -1) {
            const newQuantity = cart.items[existingItemIndex].quantity + quantity;
            if (newQuantity > 10) {
                throw new Error("Totala antalet produkter kan inte överstiga 10.");
            }
            cart.items[existingItemIndex].quantity = newQuantity;
        } else {
            cart.items.push({ productId, quantity, price });
        }

        localCart.saveCart(cart);
        return cart;
    },

    updateCartItem: (productId, quantity) => {
        if (quantity > 10) {
            throw new Error("Du kan inte ha mer än 10 av en produkt i kundvagnen.");
        }

        const cart = localCart.getCart();
        const itemIndex = cart.items.findIndex(item => item.productId === productId);

        if (itemIndex > -1) {
            if (quantity > 0) {
                cart.items[itemIndex].quantity = quantity;
            } else {
                cart.items.splice(itemIndex, 1);
            }
            localCart.saveCart(cart);
            return cart;
        } else {
            throw new Error("Produkt hittades inte i kundvagnen.");
        }
    },

    removeFromCart: (productId) => {
        const cart = localCart.getCart();
        cart.items = cart.items.filter(item => item.productId !== productId);
        localCart.saveCart(cart);
        return cart;
    },

    getCartCount: () => {
        const cart = localCart.getCart();
        return cart.items.reduce((total, item) => total + item.quantity, 0);
    },

    clearCart: () => {
        localStorage.removeItem(LOCAL_CART_KEY);
    },

    mergeWithServerCart: async () => {
        if (!auth.isAuthenticated()) return;

        const localCartData = localCart.getCart();

        if (localCartData.items.length === 0) return;

        try {
            for (const item of localCartData.items) {
                await fetch(`${process.env.REACT_APP_API_BASE_URL}/cart/add`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${auth.getToken()}`
                    },
                    body: JSON.stringify({
                        productId: item.productId,
                        quantity: item.quantity,
                        price: item.price
                    })
                });
            }

            localCart.clearCart();
        } catch (error) {
            console.error('Error merging carts:', error);
        }
    }
};

export default localCart;